import { v4 as uuidv4 } from 'uuid';

import type {
	OrderDefault,
	EntitlementDetails,
	OrderRequestDto,
} from '@atlassian/commerce-ccp-gateway-client';

const AMENDMENT_ORDER_ITEM_ID = '1';
type TypeCreateAmendmentOrderRequestDto = OrderRequestDto | undefined;
export const createAmendmentOrderRequestDto = (
	ccpOrderDefaults: OrderDefault,
	targetOfferingId: string,
	entitlement: EntitlementDetails,
): TypeCreateAmendmentOrderRequestDto => {
	if (!entitlement.entitlementId || !entitlement.version) {
		return undefined;
	}

	return {
		orderId: uuidv4(),
		invoiceGroupId: ccpOrderDefaults.invoiceGroupId?.value,
		items: [
			{
				nextBillingAnchorTimestamp: ccpOrderDefaults.billingAnchorTime?.constrained
					? ccpOrderDefaults.billingAnchorTime.value
					: undefined,
				offeringId: targetOfferingId,
				entitlement: {
					id: entitlement.entitlementId,
					version: entitlement.version.toString(),
				},
				optedUsageOptions: {
					trial: {
						skipTrial: false,
					},
					chargingDetails: {
						pricingPlanId: ccpOrderDefaults.pricingPlanId?.value,
					},
				},
				type: 'AMENDMENT_ORDER',
				itemId: AMENDMENT_ORDER_ITEM_ID,
			},
		],
	};
};
